<template>
  <h5
    class="title3-container"
    :class="device.isMobile ? 'title3-container-mobile' : ''"
    :id="content.key"
    :style="{
      fontFamily: content.textStyle.fontFamily || '',
      fontSize: (content.textStyle.fontSize + 'rem') || '',
      lineHeight: (content.textStyle.lineHeight + 'rem') || '',
      textIndent: (typeof content.textStyle.textIndent === 'string') ? content.textStyle.textIndent :
        (typeof content.textStyle.textIndent === 'number') ? (content.textStyle.textIndent + 'rem') : '',
      fontWeight: content.textStyle.fontWeight || '',
      textDecoration: content.textStyle.underline === 1 ? 'underline' : '',
      fontStyle: content.textStyle.fontItalic === 1 ? 'italic' : '',
      textAlign: content.textStyle.textAlign || '',
      color: content.textStyle.color || '',
      backgroundColor: content.textStyle.backgroundColor || '',
      backgroundImage: content.textStyle.backgroundImage ? `url(${content.textStyle.backgroundImage})` : '',
      marginTop: (content.textStyle.marginTop + 'rem') || '',
      marginBottom: (content.textStyle.marginBottom + 'rem') || '',
    }"
    v-html="content.text"
  ></h5>
</template>
<script>
/*
标题-3
*/
export default {
  name: "title-3",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.title3-container{
  width: calc(100% - 48rem);
  margin: 20rem auto;
  font-size: 22rem;
  color: #333;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-weight: bold;
}
.title3-container-mobile{
  margin: 66rem auto 20rem;
  font-size: 30rem;
}
</style>